import { createInertiaApp } from "@inertiajs/react"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers"

import Analytics from "@services/Analytics"
import Sentry from "@services/Sentry"

import "../css/app.css"

import "./setup/dayjs"
import "./setup/chartjs"

import "@helpers/streamClient"

import "@stores/i18n"

Analytics.install()
Sentry.install()

// https://vitejs.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", (event) => {
	event.preventDefault()
	window.location.reload()
})

// @ts-expect-error Import meta
if (!import.meta.env.PROD) {
	// Silence harmless warnings in development
	const warn = console.warn
	console.warn = (...args) => {
		// Filter out expected React warnings
		if (
			args.length === 1 &&
			typeof args[0] === "string" &&
			args[0].includes("ReactDOM.render")
		) {
			return
		}
		warn(...args)
	}
}

function resolvePage(name: string) {
	name = name.replace(".", "/")

	return resolvePageComponent(
		`./pages/${name}.tsx`,
		// @ts-expect-error Import meta
		import.meta.glob("./pages/**/*"),
	)
}

createInertiaApp({
	resolve: async (name: string) => {
		return await resolvePage(name)
	},

	setup({ el, App, props }) {
		const root = createRoot(el as HTMLElement)
		root.render(
			<StrictMode>
				<App {...props} />
			</StrictMode>,
		)
	},

	progress: {
		color: "#482846",
	},
})
